import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const AsideWrapper = styled.aside(() =>
  mq({
    backgroundColor: defaultTheme.background.secondary,
    padding: [
      `${defaultTheme.spacing.xxl} ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.xxl} ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.xxl} 40px`,
      `${defaultTheme.spacing.l} 0`,
    ],
    '& > div, ul': {
      width: ['100%', '100%', '100%', '1040px'],
      marginRight: 'auto',
      marginLeft: 'auto',
    },
  }),
);

export const FooterWrapper = styled(AsideWrapper)(() =>
  mq({
    backgroundColor: '#242424',
  }),
).withComponent('footer');

export const Item = styled.div(() =>
  mq({
    marginBottom: '40px',
  }),
);

export const LinkList = styled.ul((props: { isOrganized?: boolean }) =>
  mq({
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: props.isOrganized ? ['column', 'column', 'row'] : 'row',
    gap: defaultTheme.spacing.l,
    marginBottom: defaultTheme.spacing.xxl,
    '& > li': {
      color: defaultTheme.color.white,
      fontSize: defaultTheme.font.size.s,
      textDecorationLine: 'underline',
      ...hoverOpacity,
    },
  }),
);

export const ItemName = styled.p(() =>
  mq({
    color: defaultTheme.color.white,
    fontSize: defaultTheme.font.size.s,
    fontWeight: 'bold',
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const GuideLinkList = styled(LinkList)(() =>
  mq({
    '& > li': {
      color: defaultTheme.color.grayScale.medium,
      fontSize: defaultTheme.font.size.xs,
    },
  }),
);

export const CompanyLinkList = styled(LinkList)(() =>
  mq({
    margin: `${defaultTheme.spacing.l} 0 40px`,
    '& > li': {
      fontSize: defaultTheme.font.size.xs,
    },
  }),
);

export const CompanyLogo = styled.img(() =>
  mq({
    width: '90.71px',
    height: '16px',
    objectFit: 'contain',
  }),
);

export const Copyright = styled.p(() =>
  mq({
    color: defaultTheme.color.white,
    fontSize: defaultTheme.font.size.xs,
    textAlign: 'center',
  }),
);

export const OfficialAccountWrapper = styled.div(() =>
  mq({
    textAlign: 'center',
    marginBottom: '40px',
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
    ],
    '& > p': {
      marginBottom: defaultTheme.spacing.l,
    },
  }),
);

export const Accounts = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: '48px 48px',
    gridColumnGap: defaultTheme.spacing.s,
    justifyContent: 'center',
    '& > a': {
      ...hoverOpacity,
    },
  }),
);

export const TextBold = styled.p(() =>
  mq({
    fontWeight: 'bold',
    color: defaultTheme.color.white,
  }),
);
